import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Auth from "./Auth";
import ResetPass from "./ResetPass";
import Home from "./Home";
import { AuthProvider } from "./AuthContext";
import AdminHome from "./AdminHome";

const App = () => {
  console.log("App rendering");
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Auth />} />
          <Route path="/reset-password/:token" element={<ResetPass />} />
          <Route path="/home" element={<Home />} />
          <Route path="/adminhome" element={<AdminHome />} />
          <Route
            path="*"
            element={<h1 style={{ textAlign: "center" }}>404 - Not Found</h1>}
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
